export default __webpack_public_path__ + "static/media/yaoqing.cdb430c9.jpg";